import Cookies from "js-cookie";

import { config } from "shared/data";
import { detectAdBlock } from "shared/lib/ad-block";
import { gtag } from "shared/lib/gtag";

export const getGAIdFromCookie = () => {
  const gaValue = Cookies.get("_ga");
  if (!gaValue) return null;

  // GA cookie format: GA1.1.1234567890.1234567890
  const parts = gaValue.split(".");
  if (parts.length >= 2) {
    return parts.slice(-2).join(".");
  }
  return null;
};

export const getGoogleAnalyticsClientId = async () =>
  (await getGAClientIdFromGTM(config.googleAnalytics.measurementId)) ?? getGAIdFromCookie() ?? "";

export function computeGACampaignKey(name: string, variant: string) {
  const skippedVariant = new Set(["0", "1"]);
  return skippedVariant.has(variant) ? name : `${name}-${variant}`;
}

export async function getGAClientIdFromGTM(profileId: string) {
  if (typeof window === "undefined" || typeof globalThis === "undefined") return;
  if (window.getGaClientIdFromGTMPromise !== undefined) {
    return window.getGaClientIdFromGTMPromise;
  }
  window.getGaClientIdFromGTMPromise = new Promise<string | undefined>(resolve => {
    setTimeout(() => {
      resolve(undefined);
    }, 5000);
    void detectAdBlock().then(hasAdBlock => {
      if (hasAdBlock) {
        resolve(undefined);
        return;
      }
      gtag("get", profileId, "client_id", (clientId: string) => {
        resolve(clientId);
      });
    });
  });
  return window.getGaClientIdFromGTMPromise;
}

declare global {
  interface Window {
    getGaClientIdFromGTMPromise?: Promise<string | undefined>;
  }
}
